import { EmployeeRole } from "./role-type";

export interface EmployeeDTO {
  uuid?: string;
  mail: string;
  role: EmployeeRole;
  isOrganizationAdmin: boolean;
  orgUUID: string;
  isAbleToManageUsers: boolean;
}

export interface UpdateEmployeeManageUsersEvent {
  employee: EmployeeDTO;
  isAbleToManageUsers: boolean;
}

export const EMPLOYEE_SORT = {
  byEmail: (employee: EmployeeDTO): string => employee.mail,
  byPermissions: (employee: EmployeeDTO): number => {
    switch (true) {
      case employee.isOrganizationAdmin:
        return 2;
      case employee.role === EmployeeRole.ADMIN:
        return 1;
      case employee.role === EmployeeRole.VIEWER:
        return 0;
      default: return -1;
    }
  },
  byCanManageUsers: (employee: EmployeeDTO): number => employee.isAbleToManageUsers ? 1 : 0,
};
